<div class="single-banner">
  <div class="w-100 d-flex justify-content-center">
    <div class="banner-img-container">
      <img src="{{ bannerData?.img }}" default="{{ defaultImage }}" [ngStyle]="{'width.px': bannerData?.width, 'height.px': bannerData?.height}" />
    </div>
  </div>

  <div class="banner-info">
    <h1>{{ bannerData?.width }}x{{ bannerData?.height }}</h1>
    <div class="btn-container">
      <button class="choose-button" (click)="selectCurrentBanner(bannerData)">
        <h3>{{ 'view_translations.choose' | translate }}</h3>
      </button>
    </div>
  </div>
</div>
